import styles from "./InputField.module.scss";

const TextAreaField = ({
  name,
  label,
  register,
  validation,
  errors,
  required = false,
  placeholder = "",
  isStatic = false,
  readOnly = false,
}) => {
  return (
    <div className={styles.field__textArea}>
      <label className={`form-label ${styles.field__label}`}>
        {label}
        <span className={styles.field__label__required}>
          {required && !isStatic ? "必須" : ""}
        </span>
      </label>

      <textarea
        className={`${styles.field__input__textarea} ${styles.field__input}
        } ${errors[name] ? "is-invalid" : ""} ${
          isStatic ? "form-control-plaintext" : "form-control"
        }`}
        placeholder={placeholder}
        {...register(name, { ...validation, onChange: onchange })}
        readOnly={isStatic || readOnly}
      />
      <p className={`invalid-feedback ${styles.field__msg}`}>
        {errors[name] ? errors[name].message : ""}
      </p>
    </div>
  );
};

export default TextAreaField;
